(function () {
  if (window.__tvhContrastInit) return;
  window.__tvhContrastInit = true;

  function relLum(color) {
    const m = (color || '').match(/[\d.]+/g);
    if (!m || m.length < 3) return 1;
    const a = m.length >= 4 ? parseFloat(m[3]) : 1;
    if (a === 0) return 1;
    const lin = (v) => {
      v /= 255;
      return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
    };
    return 0.2126 * lin(+m[0]) + 0.7152 * lin(+m[1]) + 0.0722 * lin(+m[2]);
  }

  function bgLumAt(x, y) {
    const els = document.elementsFromPoint(x, y);
    let node = els.find((el) => !(el.closest && el.closest('#header-group')));
    while (node && node.nodeType === 1 && node !== document.documentElement) {
      const c = getComputedStyle(node).backgroundColor;
      if (c && c !== 'transparent' && !/rgba?\(\s*0,\s*0,\s*0,\s*0\s*\)/.test(c)) {
        return relLum(c);
      }
      node = node.parentElement;
    }
    return relLum(getComputedStyle(document.body).backgroundColor) || 1;
  }

  const THRESHOLD = 0.30;
  let rafId = null;
  let floatOn = false;
  let followUntil = 0;
  function placeScrollEdge(hc, on) {
    const edge = document.querySelector('.tvh-scroll-edge');
    if (!edge) return;
    const r = hc.getBoundingClientRect();
    const bottom = Math.max(0, r.top + r.height);
    edge.style.setProperty('--tvh-edge-top', Math.round(bottom) + 'px');
    edge.dataset.tvhScrolled = on ? 'on' : 'off';
  }

  function followMorph() {
    const hc = document.getElementById('header-component');
    if (hc) placeScrollEdge(hc, floatOn);
    if (performance.now() < followUntil) requestAnimationFrame(followMorph);
  }

  function update() {
    rafId = null;
    const hc = document.getElementById('header-component');
    if (!hc) return;

    var sy = window.scrollY || document.documentElement.scrollTop || 0;
    var flipped = false;
    if (!floatOn && sy > 8) {
      floatOn = true;
      hc.dataset.tvhScrolled = 'on';
      flipped = true;
    } else if (floatOn && sy <= 2) {
      floatOn = false;
      hc.dataset.tvhScrolled = 'off';
      flipped = true;
    }
    placeScrollEdge(hc, floatOn);
    if (flipped) {
      var wasFollowing = followUntil > performance.now();
      followUntil = performance.now() + 420;
      if (!wasFollowing) requestAnimationFrame(followMorph);
    }

    const r = hc.getBoundingClientRect();
    const y = Math.max(2, r.top + r.height * 0.5);
    const xs = [0.12, 0.31, 0.5, 0.69, 0.88];
    let sum = 0;
    for (const f of xs) sum += bgLumAt(innerWidth * f, y);
    hc.dataset.tvhContrast = sum / xs.length < THRESHOLD ? 'dark' : 'light';
  }

  function schedule() {
    if (rafId === null) rafId = requestAnimationFrame(update);
  }

  addEventListener('scroll', schedule, { passive: true });
  addEventListener('resize', schedule, { passive: true });
  document.addEventListener('shopify:section:load', schedule);
  schedule();
  setTimeout(schedule, 400);
  setTimeout(schedule, 1400);
})();
